/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('LoyaltyCardView', [
    "$sce", "LoyaltyCardData", "LoyaltyCardSrv", "LoyaltyCard", "SupplierView", "$filter", "StyleColor", "CurrencyManager",
    function ($sce, LoyaltyCardData, LoyaltyCardSrv, LoyaltyCard, SupplierView, $filter, StyleColor, CurrencyManager) {

        var LoyaltyCardView = function (loyaltyCard, cIndex, parentCategoryView, domainView) {
            this.cIndex = cIndex;
            this.domainView = domainView;
            this.label = "";
            this.globalType = "subs";// subs / pts (view only)
            this.type = "subs";// nbSales / pts /subs
            this.itemType = null;
            this.categoryType = "loyaltyCard";
            this.categoryTypeSortOrder = 3;
            this.monthValidity = 6;
            this.alertExp = 2;
            this.isAlertExp = false;
            this.description = "";
            this.descriptionHtml = "";
            this.price = 0;
            this.priceInput = $filter("currencyFormatFilter")(0);
            this.companyImage = null;
            this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
            this.specificImage = null;
            this.isVisibleOnWebSite = true;
            this.isBuyableOnWebSite = false;
            this.goalPts = 1;
            this.goalType = "discountPercent";  // discountPercent //discountValue
            this.goalAmount = 10;
            this.goalAmountInput = "10,00";
            this.goalText = null;
            //for views
            this.isSelected = false;
            this.isSmsSelected = false;
            this.isNotificationSelected = false;
            this.canSave = false;
            this.styleView = {};  //styleView is an object and category.style is a string
            this.colorPicker = ""; //value liked by the colorpicker
            this.mouseHover = false;
            this.form = {
                displayError: true,
                displayErrorPrice: false,
                displayErrorGoalAmount: false,
                displayErrorGoalPts: false
            };

            if (parentCategoryView !== undefined && parentCategoryView != null) {
                this.parentCategoryView = parentCategoryView;
            }
            if (loyaltyCard !== undefined && loyaltyCard != null) {
                this.loadDataFrom(loyaltyCard);
            } else {
                this.onChangeType();
            }
        }

        LoyaltyCardView.prototype.getModel = function () {
            if (this.cIndex != -1) {
                return LoyaltyCardData.getByIndex(this.cIndex);
            }
            return null;
        };

        LoyaltyCardView.prototype.loadDataFrom = function (loyaltyCard) {
            //Assume here than the object in parameter contains only id (must load them)
            this.label = loyaltyCard.label;
            this.type = loyaltyCard.type;
            this.itemType = loyaltyCard.itemType;
            if (this.type != "subs") {
                this.globalType = "pts"
            }
            this.monthValidity = loyaltyCard.monthValidity;
            this.alertExp = loyaltyCard.alertExp;
            this.isAlertExp = this.alertExp != 0;
            this.description = loyaltyCard.description;
            this.goalPts = loyaltyCard.goalPts;
            this.goalType = loyaltyCard.goalType;
            this.goalAmount = loyaltyCard.goalAmount;
            this.goalAmountInput = $filter('number')(this.goalAmount, 2);
            this.goalText = loyaltyCard.goalText;

            if (this.description) {
                this.descriptionHtml = $sce.trustAsHtml(this.description.replace("\n", "<br/>"));
            }

            this.price = loyaltyCard.price;
            this.priceInput = $filter('currencyFormatFilter')(this.price);

            this.isVisibleOnWebSite = loyaltyCard.isVisibleOnWebSite;
            this.isBuyableOnWebSite = loyaltyCard.isBuyableOnWebSite;

            this.specificImage = loyaltyCard.specificImage;
            this.image = loyaltyCard.image;
            this.companyImage = loyaltyCard.companyImage;
            if (this.image || this.companyImage) {//for ascendencing compatibility
                this.specificImage = true;
            }

            if (this.parentCategoryView && this.image == null && this.specificImage == false) {
                this.image = this.parentCategoryView.image;
            }

            if (this.parentCategoryView && this.companyImage == null && this.specificImage == false) {
                this.companyImage = this.parentCategoryView.companyImage;
            }

            if (this.companyImage) {
                this.imageDisplayed = this.companyImage;
            } else {
                this.imageDisplayed = this.image;
            }

            if (loyaltyCard.style) {
                try {
                    this.styleView = angular.fromJson(loyaltyCard.style);
                    if (this.styleView)
                        this.colorPicker = this.styleView.background;
                } catch (ex) {
                    console.log("Error loading style")
                }
            }

            this.updateCanSave();
        };

        LoyaltyCardView.prototype.updatePriceInputArrow = function (number) {
            if (this.priceInput != null && typeof this.priceInput === 'string') {
                var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
                var price = parseFloat(priceStr);
                if (isNaN(price)) {
                    this.form.displayErrorPrice = true;
                } else {
                    price += number;
                    price = price < 0 ? 0 : price;
                    this.form.displayErrorPrice = false;
                }
                this.priceInput = $filter('currencyFormatFilter')(price);
                this.onPriceInputChange();
            }
        };

        LoyaltyCardView.prototype.onPriceInputChange = function () {
            if (this.priceInput != null && typeof this.priceInput === 'string') {
                const priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
                let price = parseFloat(priceStr);
                if (isNaN(price) || price < 0) {
                    this.price = 0;
                    this.isBuyableOnWebSite = false;
                    this.form.displayErrorPrice = true;
                } else if (price === 0) {
                    this.price = 0;
                    this.isBuyableOnWebSite = false;
                    this.form.displayErrorPrice = false;
                } else {
                    this.price = price;
                    this.form.displayErrorPrice = false;
                }
            }
            this.updateCanSave();
        };

        LoyaltyCardView.prototype.updateGoalPtsInputArrow = function (number) {
            if (this.goalPts != null) {
                if (typeof this.goalPts === 'string') {
                    const goalPtsStr = CurrencyManager.getPriceFromPriceInput(this.goalPts);
                    let goalPts = parseInt(goalPtsStr);
                    if (isNaN(goalPts)) {
                        this.form.displayErrorGoalPts = true;
                    } else {
                        goalPts += number;
                    }
                    this.goalPts = $filter('number')(goalPts, 0);
                } else if (typeof this.goalPts === 'number') {
                    this.goalPts += number;
                }
                this.onGoalPtsInputChange();
            }
        };

        LoyaltyCardView.prototype.onGoalPtsInputChange = function () {
            this.form.displayErrorGoalPts = isNaN(this.goalPts) || this.goalPts < 1 || this.goalPts > 700;
            this.updateCanSave();
        };

        LoyaltyCardView.prototype.updateGoalAmountInputArrow = function (number) {
            if (this.goalAmountInput != null && typeof this.goalAmountInput === 'string') {
                const goalAmountStr = CurrencyManager.getPriceFromPriceInput(this.goalAmountInput);
                let goalAmount = parseFloat(goalAmountStr);
                if (isNaN(goalAmount)) {
                    this.form.displayErrorGoalAmount = true;
                } else {
                    goalAmount += number;
                }
                this.goalAmountInput = $filter('number')(goalAmount, 2);
                this.onGoalAmountInputChange();
            }
        };

        LoyaltyCardView.prototype.onGoalAmountInputChange = function () {
            if (this.goalAmountInput != null && typeof this.goalAmountInput === 'string') {
                var goalAmountStr = CurrencyManager.getPriceFromPriceInput(this.goalAmountInput);
                var goalAmount = parseFloat(goalAmountStr);
                if (isNaN(goalAmount)) {
                    this.form.displayErrorGoalAmount = true;
                    this.goalAmount = null;
                } else if (goalAmount < 0) {
                    this.form.displayErrorGoalAmount = true;
                } else if (goalAmount > 100 && this.goalType === 'discountPercent') {
                    this.form.displayErrorGoalAmount = true;
                } else {
                    this.form.displayErrorGoalAmount = false;
                    this.goalAmount = goalAmount;
                }
            }
            this.updateCanSave();

        };

        LoyaltyCardView.prototype.onMonthValidityChange = function () {
            if (this.monthValidity != null && typeof this.monthValidity === 'string') {
                const goalAmountStr = CurrencyManager.getPriceFromPriceInput(this.monthValidity);
                this.monthValidity = parseInt(goalAmountStr);
            }
            if (isNaN(this.monthValidity)) {
                this.form.displayErrorMonthValidity = true;
            } else {
                this.form.displayErrorMonthValidity = this.monthValidity <= 0;
            }
            this.updateCanSave();
        };

        LoyaltyCardView.prototype.onIsAlertExpChange = function () {
            if (this.isAlertExp)
                this.alertExp = 2;
            else
                this.alertExp = 0;
        };

        LoyaltyCardView.prototype.onAlertExpChange = function () {
            if (this.alertExp != null && typeof this.alertExp === 'string') {
                const goalAmountStr = CurrencyManager.getPriceFromPriceInput(this.alertExp);
                this.alertExp = parseInt(goalAmountStr);
            }
            if (this.alertExp == 0) {
                this.isAlertExp = false;
            }
        };

        LoyaltyCardView.prototype.isChanged = function () {
            //TODO
            var loyaltyCard = this.getModel();
            if (loyaltyCard) {
                var image = loyaltyCard.image;
                if (image == null && loyaltyCard.parentCategory && loyaltyCard.specificImage == false)
                    image = loyaltyCard.parentCategory.image;
                var companyImage = loyaltyCard.companyImage;
                if (companyImage == null && loyaltyCard.parentCategory && loyaltyCard.specificImage == false)
                    companyImage = loyaltyCard.parentCategory.companyImage;

                return (
                    this.label != loyaltyCard.label ||
                    this.type != loyaltyCard.type ||
                    this.itemType != loyaltyCard.itemType ||
                    this.goalType != loyaltyCard.goalType ||
                    this.description != loyaltyCard.description ||
                    this.price != loyaltyCard.price ||
                    this.specificImage != loyaltyCard.specificImage ||
                    this.image !== image ||
                    this.companyImage !== companyImage);
            } else
                return true;
        };

        LoyaltyCardView.prototype.setImage = function (image) {
            this.image = image;
            this.companyImage = null;
            this.imageDisplayed = this.image;
        };

        LoyaltyCardView.prototype.setCompanyImage = function (companyImage) {
            this.image = null;
            this.companyImage = companyImage;
            this.imageDisplayed = this.companyImage;
        };

        LoyaltyCardView.prototype.copyDataTo = function (loyaltyCard) {
            //Assume here than the object in parameter contains only id (must load them)
            loyaltyCard.label = this.label;
            loyaltyCard.type = this.type;
            loyaltyCard.itemType = this.itemType;
            loyaltyCard.monthValidity = this.monthValidity;
            loyaltyCard.alertExp = this.alertExp;
            loyaltyCard.description = this.description;
            loyaltyCard.price = this.price;
            loyaltyCard.image = this.image;
            loyaltyCard.companyImage = this.companyImage;
            loyaltyCard.specificImage = this.specificImage;
            loyaltyCard.isVisibleOnWebSite = this.isVisibleOnWebSite;
            if (this.price < 0 && this.isBuyableOnWebSite) {
                loyaltyCard.isBuyableOnWebSite = false;
                this.isBuyableOnWebSite = false;
            } else {
                loyaltyCard.isBuyableOnWebSite = this.isBuyableOnWebSite;
            }

            if (this.goalPts <= 0 && this.type !== "subs") {
                loyaltyCard.goalPts = 300;
                this.goalPts = 300;
            } else {
                loyaltyCard.goalPts = this.goalPts;
            }

            loyaltyCard.goalType = this.goalType;
            loyaltyCard.goalAmount = this.goalAmount;
            loyaltyCard.goalText = this.goalText;

            if (this.styleView)
                loyaltyCard.style = angular.toJson(this.styleView);
            else
                loyaltyCard.style = null;
        };

        LoyaltyCardView.prototype.onSpecificImageChange = function () {
            if (!this.specificImage) {
                this.image = null;
                this.companyImage = null;
            }
        };

        LoyaltyCardView.prototype.updateModel = function () {
            var loyaltyCard = this.getModel();
            if (loyaltyCard == null) {
                loyaltyCard = new LoyaltyCard();
                this.cIndex = LoyaltyCardData.getIndexOf(loyaltyCard);
            }

            if (!this.specificImage && this.parentCategoryView !== undefined && this.parentCategoryView.label !== "Racine") {
                this.image = this.parentCategoryView.image;
                loyaltyCard.image = this.image;
            }

            this.copyDataTo(loyaltyCard);

            var category = this.parentCategoryView.getModel();
            if (category && category !== loyaltyCard.parentCategory) { // change of category
                if (loyaltyCard.parentCategory)
                    loyaltyCard.parentCategory.removeLoyaltyCard(loyaltyCard);
                category.addLoyaltyCard(loyaltyCard);
            }
            LoyaltyCardSrv.save(loyaltyCard);
        };

        LoyaltyCardView.prototype.removeModel = function () {
            var loyaltyCard = this.getModel();
            if (loyaltyCard != null) {
                loyaltyCard.parentCategory.removeLoyaltyCard(loyaltyCard);
                LoyaltyCardSrv.remove(loyaltyCard);
            }
        };

        LoyaltyCardView.prototype.reloadModel = function () {
            var loyaltyCard = this.getModel();
            if (loyaltyCard == null) {
                this.parentCategoryView.removeLoyaltyCardView(this);
            } else {
                this.loadDataFrom(loyaltyCard);
            }
        };

        LoyaltyCardView.prototype.restoreModel = function () {
            //undeleted
            var loyaltyCard = this.getModel();
            if (loyaltyCard) {
                if (loyaltyCard.parentCategory)
                    loyaltyCard.parentCategory.addLoyaltyCard(loyaltyCard);
                LoyaltyCardSrv.restore(loyaltyCard);
            }
        };

        LoyaltyCardView.prototype.updateCanSave = function () {
            if
            (
                (this.label && this.label != "") //titre
                && (!this.form.displayErrorPrice)
                && (!this.form.displayErrorGoalAmount)
                && (!this.form.displayErrorGoalPts)
            ) {
                this.canSave = true;
            } else {
                this.canSave = false;
            }
        };

        LoyaltyCardView.prototype.search = function (searchedTextLC) {
            if (searchedTextLC && this.label.toLowerCase().indexOf(searchedTextLC) != -1 || (this.image && this.image.keyWords.indexOf(searchedTextLC) != -1)) {
                return true;
            }
            return false;
        };

        LoyaltyCardView.prototype.onChangeType = function () {
            if (this.type == "subs") {
                this.goalPts = 0;
                this.goalType = "discountPercent";
                this.goalAmount = 10;
            } else if (this.type == "nbSales") {
                this.goalPts = 10;
                this.goalType = "discountPercent";
                this.goalAmount = 10;
            } else {
                this.goalPts = 300;
                this.goalAmount = 30;
                this.goalType = "discountValue";
            }
            this.goalAmountInput = $filter('number')(this.goalAmount, 2);
        };

        LoyaltyCardView.prototype.onStyleViewChange = function () {
            if (!this.styleView || this.styleView.color != this.colorPicker) {
                if (!this.styleView) {
                    this.styleView = {};
                }

                this.styleView.color = StyleColor.getContrastYIQ(this.colorPicker);
                this.styleView.background = this.colorPicker;
            }
        }

        return LoyaltyCardView;
    }
]);



// WEBPACK FOOTER //
// ./js/services/views/LoyaltyCardView.js